import React, {useEffect} from 'react';
import useCurrentShortcut from "@hooks/useCurrentShortcut";

const ShortcutLink = props => {
    const {shortcutId, shortcutUrl, hash, className = '', ...other} = props;
    const {loadShortcutByUrl} = useCurrentShortcut();

    const handleClick = () => {
        if(hash){
            loadShortcutByUrl(shortcutUrl,null,hash);
        }else{
            loadShortcutByUrl(shortcutUrl);
        }
    }

    useEffect(() => {
        $('.ch-shortcut-link .ch-mathjax').reloadMathJax();
    },[]);

    return (
        <span className={'ch-shortcut-link ' + className} onClick={handleClick} {...other}>
            {props.children}
        </span>
    )
}

export default ShortcutLink;